import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const OrdersHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-shadow: 0px 1px 0px ${({ theme }) => theme.colors.grey000};
`;

export const OrdersHeaderFilterWrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;

export const OrdersHeaderFilterItemWrapper = styled.div`
  padding: 17px 16px;
  cursor: pointer;

  ${({ selected, theme }) =>
    selected &&
    `
    color: ${theme.colors.blueMain};
    box-shadow: inset 0 -4px 0 ${theme.colors.blueMain};
  `}
`;

export const OrdersHeaderFilterItem = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
`;

export const OrdersHeaderCreateOrderButton = styled(typography.BodyTextOneRegularTypography)`
  padding: 8px 42px;
  height: fit-content;
  color: ${({ theme }) => theme.colors.white};
  border: 0;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.blueMain};
  cursor: pointer;
`;
